// Lightweight, non-React guard so components that navigate imperatively
// (e.g. the Sidebar's `navigate(path)` calls) can be paused when another
// part of the app has unsaved changes and wants to confirm before leaving.
//
// A page with unsaved changes calls `setNavigationGuard(fn)` on mount/while
// dirty, and `clearNavigationGuard()` once saved/discarded or on unmount.
// Anything that navigates imperatively should call `requestNavigation(path)`
// first: if it returns true, no guard is active and it's safe to navigate
// immediately; if false, the guard has taken over (e.g. shows a confirm
// modal) and is responsible for navigating itself once the user decides.

let guardFn = null;

export const setNavigationGuard = (fn) => {
  guardFn = fn;
};

export const clearNavigationGuard = () => {
  guardFn = null;
};

export const requestNavigation = (path) => {
  if (guardFn) {
    guardFn(path);
    return false;
  }
  return true;
};
